var map = {
	"./arrow-down.svg": 7007,
	"./arrow.svg": 310,
	"./arrow2.svg": 7112,
	"./branch-consumer-stable.svg": 6672,
	"./branch-finance.svg": 982,
	"./branch-health.svg": 3590,
	"./branch-industry.svg": 6958,
	"./branch-real-estate.svg": 9313,
	"./checkmark.svg": 3490,
	"./circle-minus.svg": 176,
	"./circle-plus.svg": 7448,
	"./file.svg": 1349,
	"./paperclip.svg": 3609,
	"./quartile/Quartile_1.svg": 6000,
	"./quartile/Quartile_2.svg": 2099,
	"./quartile/Quartile_3.svg": 9058,
	"./quartile/Quartile_4.svg": 2989,
	"./star-filled.svg": 8320,
	"./star.svg": 9455,
	"./stock-sectors/sectorBasicMaterials.svg": 6002,
	"./stock-sectors/sectorCommunicationServices.svg": 5762,
	"./stock-sectors/sectorConsumerDefensive.svg": 5497,
	"./stock-sectors/sectorEnergy.svg": 8342,
	"./stock-sectors/sectorFinancialServices.svg": 7599,
	"./stock-sectors/sectorHealthcare.svg": 1667,
	"./stock-sectors/sectorIndustrials.svg": 738,
	"./stock-sectors/sectorRealEstate.svg": 5346,
	"./stock-sectors/sectorTechnology.svg": 672,
	"./stock-sectors/sectorUtilities.svg": 826,
	"./stock-sectors/superSectorCyclical.svg": 3629,
	"./stylebox/StyleBox_Equity_1.svg": 2056,
	"./stylebox/StyleBox_Equity_2.svg": 123,
	"./stylebox/StyleBox_Equity_3.svg": 2602,
	"./stylebox/StyleBox_Equity_4.svg": 9781,
	"./stylebox/StyleBox_Equity_5.svg": 2532,
	"./stylebox/StyleBox_Equity_6.svg": 6983,
	"./stylebox/StyleBox_Equity_7.svg": 8006,
	"./stylebox/StyleBox_Equity_8.svg": 9185,
	"./stylebox/StyleBox_Equity_9.svg": 1152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1980;